<template>
    <div class="filter-checkboxes">
        <template v-for="(option, index) in filter.options">
            <input :id="'checkbox-' + filter.name + '-' + index" :checked="checked" class="form-input form__input--checkbox checkbox-style--2" @click="select(option)" type="checkbox"/><label :for="'checkbox-' + filter.name + '-' + index" v-html="filter.title"></label>
        </template>
    </div>
</template>

<script>
import {constants} from "@productfinder/shared/constants";

export default {
        name: "sal-filter-checkbox",
        props: {
            filter: {}
        },
        computed: {
            checked() {
                return !!this.$store.getters.selectedFilters[this.filter.name]
            },
            constants() {
                return constants
            }
        },
        methods: {
            select(value) {
                if (!this.checked) {
                    this.$store.dispatch('setFilterState', { filterName: this.filter.name, value: value })
                } else {
                    this.$store.dispatch('removeFilterState', { filterName: this.filter.name, value: value })
                }
            }
        }
    }
</script>
